import { AxiosInstance } from 'axios';

const SECURE_ASSETS_BULK_FETCH = '/api/v3.1/secure-assets/bulk/fetch';

export default class CoreAssetService {
    constructor(readonly axios: AxiosInstance) {}

    public secureUrlForAsset(url: string): Promise<string> {
        return this.axios
            .request({ url: SECURE_ASSETS_BULK_FETCH, method: 'POST', data: [url] })
            .then(r => r.data[url]); // [{"url": "secureUrl"}]
    }
}
